import { mockTeamA } from './mockTeamA'
import { MOCK_TEAM_A_ID } from './mockTeamsConstants'
import { TeamsReducer } from 'state/reducers/types/TeamsReducer'

export const mockTeams: TeamsReducer = {
  [MOCK_TEAM_A_ID]: mockTeamA,
}
